import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { User } from '@app/_models';
import { AccountService } from '@app/_services';
import { CourseService } from '@app/_services/course.service';
import { MixpanelService } from '@app/_services/mixpanel.service';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {
        
    user: User;
    public signupEmail: string = "";
    public signupForm: FormGroup;
    public confirmationForm: FormGroup;
    public successfullySignup: boolean;
    public confirmationCodeSuccess: boolean = false;
    private self: any = this;
    public processing = false;

    private validPassword:boolean = true;
    private emailExists: boolean = false;
    private invalidEmail: boolean = false;
    private invalidCode: boolean = false;

    data: any = {
        courses: [{
            name: "German Basic",
            url: "/german-basic-course",
            unit: "Unit 1",
            image: '/assets/fsi-german-basic-unit-01.png'
        },
        {
            name: "Spanish Basic",
            url: "/spanish-basic-course",
            unit: "Unit 1",
            image: '/assets/fsi-spanish-basic-unit-01.png'
        },
        {
            name: "French Basic",
            url: "/french-basic-course",
            unit: "Unit 1",
            image: '/assets/fsi-french-basic-unit-01.png'
        }]
    }    

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private auth: AccountService,
        private mixpanel: MixpanelService
    ) {
        //this.user = this.accountService.userValue;        
    }

    ngOnInit() {
        this.initForm();
      }
    
    initForm() {
      this.signupForm = this.fb.group({   
        'email': ['', Validators.required],
        'password': ['', Validators.required]
      });
      this.confirmationForm = this.fb.group({
        'email': ['', Validators.required],
        'confirmationCode': ['', Validators.required]
      });
    }

  onSubmitSignup(value: any) {
    this.processing = true;
    this.validPassword = true;
    this.emailExists = false;
    this.invalidEmail = false;
    this.invalidCode = false;

    const email = value.email, password = value.password;
    this.signupEmail = email;
    this.auth.signUp(email, password)
      .subscribe(
        result => {
          this.successfullySignup = true;
          this.processing = false;          

          this.mixpanel.people().set(email, {
            $email: email,              
            $created: (new Date().toISOString())
          });

          this.mixpanel.identify(email);
          this.mixpanel.track('Signed Up');

          setTimeout(function(context) {                                            

            context.router.navigate(['/login']);
          }, 2000, this.self);
          
        },
        error => {
          if (error.code === 'InvalidParameterException' && error.message === 'Username should be an email.') {
            this.invalidEmail = true;
          } else if (error.code === 'InvalidParameterException') {
            this.validPassword = false;
          } else if (error.code === "InvalidPasswordException") {
            this.validPassword = false;          
          } else if (error.code === 'UsernameExistsException') {
            this.emailExists = true;
          }
          console.log(error);
          
          setTimeout(function(context) {
            context.processing = false;
          }, 1200, this.self);
        });
  }
}